import { FC } from "react";
import { Loader } from "@monolith-forensics/monolith-ui";
import { DataImportModal } from "../../_components/DataImport";
import { useAcquisitionImportDefinition } from "../Import";

interface AcquisitionDataImportModalProps {
  open: boolean;
  onClose: () => void;
  onComplete?: () => void;
  caseId: number;
}

export const AcquisitionDataImportModal: FC<AcquisitionDataImportModalProps> =
  ({ open, onClose, onComplete, caseId }) => {
    const { definition, isLoading } = useAcquisitionImportDefinition({
      case_id: caseId,
    });

    if (isLoading || !definition) {
      if (open) {
        return (
          <div
            style={{
              position: "fixed",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <Loader />
          </div>
        );
      }
      return null;
    }

    return (
      <DataImportModal
        open={open}
        onClose={onClose}
        definition={definition}
        onComplete={onComplete}
      />
    );
  };
